import { render, staticRenderFns } from "./BasicReq.vue?vue&type=template&id=b901520a&scoped=true&"
import script from "./BasicReq.vue?vue&type=script&lang=js&"
export * from "./BasicReq.vue?vue&type=script&lang=js&"
import style0 from "./BasicReq.vue?vue&type=style&index=0&id=b901520a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b901520a",
  null
  
)

export default component.exports